module.exports = __webpack_public_path__ + "static/media/tulsi nagar-Model_page-0001.6e098208.jpg";